import { render } from "./P039.vue?vue&type=template&id=63d79b77&scoped=true"
import script from "./P039.vue?vue&type=script&lang=js"
export * from "./P039.vue?vue&type=script&lang=js"

import "./P039.vue?vue&type=style&index=0&id=63d79b77&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d79b77"]])

export default __exports__